var cov_1dn02vqtfu = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldError.tsx",
      hash = "92ebcc8bd517655283b0476d1fff92dee149ebea",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldError.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 7,
          column: 30
        }
      },
      "1": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 46
        }
      },
      "2": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 46
        }
      },
      "3": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 46
        }
      },
      "4": {
        start: {
          line: 12,
          column: 35
        },
        end: {
          line: 12,
          column: 46
        }
      },
      "5": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 46
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 46
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 46
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 46
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldError.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { formClass } from './styles';

var FieldError =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FieldError, _PureComponent);

  var _super = _createSuper2(FieldError);

  function FieldError() {
    _classCallCheck(this, FieldError);

    return _super.apply(this, arguments);
  }

  _createClass(FieldError, [{
    key: "render",
    value: function render() {
      cov_1dn02vqtfu.f[0]++;

      var _ref = (cov_1dn02vqtfu.s[0]++, this.props),
          error = _ref.error; // eslint-disable-next-line


      cov_1dn02vqtfu.s[1]++;

      if (Array.isArray(error)) {
        cov_1dn02vqtfu.b[0][0]++;
        cov_1dn02vqtfu.s[2]++;
        error = error[0];
      } else {
        cov_1dn02vqtfu.b[0][1]++;
      }

      cov_1dn02vqtfu.s[3]++;

      if (!(error instanceof Error)) {
        cov_1dn02vqtfu.b[1][0]++;
        cov_1dn02vqtfu.s[4]++;
        return null;
      } else {
        cov_1dn02vqtfu.b[1][1]++;
      }

      cov_1dn02vqtfu.s[5]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('error'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 14,
            columnNumber: 12
          }
        }, error.message)
      );
    }
  }]);

  return FieldError;
}(PureComponent);

export default FieldError;